import { CookieManager } from "./utils/cookie-manager";

export class ThemeController {
    private cookieManager = new CookieManager();
    public currentTheme: string = "light";

    constructor() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this._initialize.bind(this));
        } else {
            this._initialize();
        }
    }

    private _initialize(): void {
        this.currentTheme = this.cookieManager.get('theme') ?? 'light';
        const themeToggleButton = document.getElementById('theme-toggle');
        if (themeToggleButton) {
            themeToggleButton.addEventListener('click', this.toggleTheme.bind(this));
        }
    }

    toggleTheme(): void {
        const newTheme = this.currentTheme === 'light' ? 'dark' : 'light';
        this.currentTheme = newTheme;
        document.documentElement.setAttribute('data-theme', this.currentTheme);
        this.cookieManager.upsert({ name: 'theme', value: this.currentTheme, days: 365 });
        this._dispatchThemeChangeEvent();
    }

    private _dispatchThemeChangeEvent(): void {
        document.dispatchEvent(new CustomEvent('themeChange', {
            detail: { theme: this.currentTheme }
        }));
    }
}
